var React = require('react');

function SDCZoomOut18N1 (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M17.247,16.18649l-4.33492-4.33493a6.26629,6.26629,0,1,0-1.06055,1.06055l4.335,4.33489a.5.5,0,0,0,.7071,0l.35344-.35344A.5.5,0,0,0,17.247,16.18649ZM8,12.75A4.75,4.75,0,1,1,12.75,8,4.75,4.75,0,0,1,8,12.75Z","fill":"var(--iconFill, #464646)","key":0}),React.createElement("rect",{"x":"5","y":"7.25","width":"6","height":"1.5","rx":"0.5","fill":"var(--iconFill, #464646)","key":1})]));
}

SDCZoomOut18N1.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SDCZoomOut18N1;

SDCZoomOut18N1.default = SDCZoomOut18N1;
